import contentService from '@/services/http/content/ContentService'
import CheckinContent from '@/objects/CheckinContent'
import profileService from '@/services/http/profile/ProfileService'

export const checkin = () => {
  return {
    namespaced: true,
    state: {
      loading: false,
      content: new CheckinContent()
    },
    mutations: {
      SET_LOADING (state, status) {
        state.loading = status
      },
      SET_CONTENT (state, content) {
        state.content = content
      },
    },
    actions: {
      async fetchCheckin ({ commit }) {
        commit('SET_LOADING', true)
        const checkinContent = await contentService.fetchCheckinContent()
        commit('SET_CONTENT', checkinContent)
        commit('SET_LOADING', false)
      },
      async fetchPreCheckins ({ commit }) {
        return profileService.fetchPreCheckins()
          .then(response => {
            commit('SET_RESERVATIONS', [response.reservation])
            commit('SET_CURRENT_RESERVATION', parseReservation(response))
          })
      }
    }
  }
}
